import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUp.css";
import config from "../../config";
import logo from "../../Images/logo.jpg";

axios.defaults.baseURL = config.BASE_URL;

const SignUp = () => {
  const [username, setUsername] = useState("");
  const [profile, setProfile] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [business, setBusiness] = useState("");
  const [businessError, setBusinessError] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [progress, setProgress] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear previous errors
    setBusinessError("");
    setUsernameError("");
    setEmailError("");
    setError("");

    if (!username || !profile || !email || !business) {
      if (!business) {
        setBusinessError("Please select a business");
      }
      if (!username) {
        setUsernameError("Username is required");
      }
      if (!email) {
        setEmailError("Email is required");
      }
      return;
    }

    setIsProcessing(true);
    setStatusMessage("Verifying email...");
    setProgress(25);

    try {
      // Step 1: Verify Email
      const verifyRes = await axios.post("/verify-email", { email, business });
      console.log("Email verification response:", verifyRes.data);
      
      if (!verifyRes.data?.isValid) {
        setStatusMessage("");
        setProgress(0);
        setIsProcessing(false);
        setEmailError("The provided email doesn't appear to be valid or reachable.");
        return;
      }

      // Step 2: Proceed with signup
      setStatusMessage("Signing you up...");
      setProgress(50);

      const response = await axios.post(
        "/signup",
        {
          username,
          profile,
          email,
          business,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      console.log("Signup response:", response.data);
      console.log(`Form submitted with ${username}, ${profile} and ${business}`);

      // Show success messages
      setTimeout(() => {
        setStatusMessage("User created successfully...");
        setProgress(75);

        setTimeout(() => {
          setStatusMessage("Redirecting to login page");
          setProgress(100);

          setTimeout(() => {
            navigate("/");
          }, 1000);
        }, 1000);
      }, 1000);

    } catch (error) {
      setStatusMessage("");
      setProgress(0);
      setIsProcessing(false);

      const errMsg = error?.response?.data?.message || error.message;
      
      // Handle specific errors
      if (errMsg.toLowerCase().includes("username") && 
          (errMsg.toLowerCase().includes("exist") || 
           errMsg.toLowerCase().includes("taken") ||
           errMsg.toLowerCase().includes("already"))) {
        setUsernameError(errMsg);
      } else if (errMsg.toLowerCase().includes("email") && 
                 (errMsg.toLowerCase().includes("exist") || 
                  errMsg.toLowerCase().includes("taken") ||
                  errMsg.toLowerCase().includes("already") ||
                  errMsg.toLowerCase().includes("invalid"))) {
        setEmailError(errMsg);
      } else {
        alert(errMsg);
      }
      
      console.error("Signup error:", error);
    }
  };

  return (
    <>
      {/* Background Animation */}
      {/* <div className="signup-background">
        <div className="animator-container"></div>
        
        <div className="moving-truck truck-1">
          <div className="truck-wheel"></div>
        </div>
        <div className="moving-truck truck-2">
          <div className="truck-wheel"></div>
        </div>
        
        <div className="delivery-message delivery-1">
          🚚 Secure Signup Process
        </div>
        <div className="delivery-message delivery-2">
          🔒 Data Protection
        </div>
        <div className="delivery-message delivery-3">
          📝 Quick Registration
        </div>
      </div> */}

      {isProcessing && (
        <div className='signup-fullscreen-overlay'>
          <div className='signup-progress-container'>
            <div className='signup-status-message'>
              {statusMessage}
            </div>
            <div className='signup-progress-visual'>
              <div className='signup-progress-truck'></div>
              <div className='signup-progress-road'></div>
            </div>
            <div className='signup-progress-bar'>
              <div 
                className='signup-progress-fill' 
                style={{width: `${progress}%`}}
              ></div>
            </div>
            <div className='signup-progress-percentage'>
              {progress}%
            </div>
          </div>
        </div>
      )}

      <div className="signup-container">
        <div className="signup-card">
          <div className="signup-logo-container">
            <img src={logo} alt="logo" className="signup-logo" />
          </div>

          <div className="signup-header">
            <h2>MFT Logistics</h2>
            <h4>Create Account</h4>
          </div>

          <form autoComplete="off" onSubmit={handleSubmit} className="signup-form">
            <div className="signup-form-group">
              <label htmlFor="business">BUSINESS *</label>
              <select
                id="business"
                name="business"
                value={business}
                onChange={(e) => {
                  setBusiness(e.target.value);
                  setBusinessError("");
                }}
                required
                className={`signup-input ${businessError ? "signup-input-error" : ""}`}
              >
                <option value="">Select business</option>
                <option value="shree">Business_1</option>
                <option value="lalchand">Business_2</option>
              </select>
              {businessError && (
                <span className="signup-error-message">{businessError}</span>
              )}
            </div>

            <div className="signup-form-group">
              <label htmlFor="username">USERNAME *</label>
              <input
                type="text"
                placeholder="Enter your username"
                id="username"
                name="username"
                autoComplete="off"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setUsernameError("");
                }}
                required
                className={`signup-input ${usernameError ? "signup-input-error" : ""}`}
              />
              {usernameError && (
                <span className="signup-error-message">{usernameError}</span>
              )}
            </div>

            <div className="signup-form-group">
              <label htmlFor="email">EMAIL *</label>
              <input
                type="email"
                placeholder="Enter your email"
                id="email"
                name="email"
                autoComplete="off"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailError("");
                }}
                required
                className={`signup-input ${emailError ? "signup-input-error" : ""}`}
              />
              {emailError && (
                <span className="signup-error-message">{emailError}</span>
              )}
            </div>

            <div className="signup-form-group">
              <label htmlFor="profile">PROFILE *</label>
              <select
                id="profile"
                name="profile"
                value={profile}
                onChange={(e) => setProfile(e.target.value)}
                required
                className="signup-input"
              >
                <option value="">Select your profile</option>
                <option value="driverAssociate">Driver Associate</option>
                <option value="loadingManager">Loading Manager</option>
                <option value="unloadingManager">Unloading Manager</option>
                <option value="accountant">Accountant</option>
                <option value="admin">Admin</option>
              </select>
            </div>

            <button className="signup-submit-button" type="submit">
              Sign Up
            </button>
          </form>

          <div className="signup-links">
            <div className="signup-link-text">
              Already have an account?{" "}
              <span 
                className="signup-link-action"
                onClick={() => navigate("/")}
              >
                Login
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;